<template>
  <div class>
    <div class="centerx">
      <vs-popup
        class="holamundo"
        v-bind:title="'Ajuda - Cadastro da Edificação'"
        :active.sync="popupActivo"
      >
        <div v-html="textoAjuda"></div>
      </vs-popup>
    </div>
    <div
      class="card card-header list-group-item list-group-item-action active mb-3"
    >
      <h4 class="mb-0">Cadastro da Empresa</h4>
      <div
        class="badge bagde-default"
        @click="popupActivo = true"
        style="position: absolute; top: 17px; right: 15px"
      >
        Ajuda <i class="fa fa-question-circle"></i>
      </div>
    </div>

    <ul
      class="process-steps row ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
      role="tablist"
    >
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{ 'ui-tabs-active ui-state-active': etapa == 'Empresa' }"
        role="tab"
        tabindex="0"
        aria-controls="ptab1"
        aria-labelledby="ui-id-1"
        aria-selected="true"
        aria-expanded="true"
      >
        <a
          @click.prevent="fnEstapa('Empresa')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-1"
          >1</a
        >
        <h5>Dados da Empresa</h5>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{ 'ui-tabs-active ui-state-active': etapa == 'Socios' }"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEstapa('Socios')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-2"
          >2</a
        >
        <h5>Sócios</h5>
      </li>
    </ul>
    <div class="card">
      <form style="padding: 15px" v-show="etapa == 'Empresa'" autocomplete="off">
        <h4 class="mb-3">Dados da empresa</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="_form-RazaoSocial">Razão Social</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.razaoSocial"
              id="_form-RazaoSocial"
              required
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-InscricaoMunicioal">Incrição municipal</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.inscricaoMunicioal"
              id="_form-InscricaoMunicioal"
              required
              maxlength="25"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-InscricaoEstadual">Incrição Estadual</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.inscricaoEstadual"
              id="_form-InscricaoEstadual"
              required
              maxlength="25"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-CapitalSocial">Capital Social</label>
            <vue-numeric
              currency="R$"
              v-bind:precision="2"
              separator="."
              type="text"
              class="form-control"
              v-model="cadastro.capitalSocial"
              id="_form-CapitalSocial"
              required
            />
          </div>
        </div>
        <h4 class="mb-3">Localização</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="_form-Logradouro">Logradouro</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.logradouro"
              id="_form-Logradouro"
              required
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Tipo">Tipo</label>
            <select class="form-control" v-model="cadastro.tipo" id="_form-Tipo">
              <option value=""></option>
              <option value="Alameda">Alameda</option>
              <option value="Avenida">Avenida</option>
              <option value="Chácara">Chácara</option>
              <option value="Condomínio">Condomínio</option>
              <option value="Distrito">Distrito</option>
              <option value="Estrada">Estrada</option>
              <option value="Loteamento">Loteamento</option>
              <option value="Pátio">Pátio</option>
              <option value="Quadra">Quadra</option>
              <option value="Residencial">Residencial</option>
              <option value="Rodovia">Rodovia</option>
              <option value="Rua">Rua</option>
              <option value="Setor">Setor</option>
              <option value="Travessa">Travessa</option>
              <option value="Via">Via</option>
              <option value="vila">Vila</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Quadra">Quadra</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.quadra"
              id="_form-Quadra"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Bloco">Bloco</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.bloco"
              id="_form-Bloco"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Lote">Lote</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.lote"
              id="_form-Lote"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Numero">Número</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.numero"
              id="_form-Numero"
              maxlength="10"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Complemento">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.complemento"
              id="_form-Complemento"
              maxlength="50"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="_form-CEP">CEP</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.cep"
              id="_form-CEP"
              maxlength="8"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Bairro">Bairro</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.bairro"
              id="_form-Bairro"
              maxlength="50"
              required
            />
          </div>
          <div class="form-group col-md-2">
            <label for="_form-UF">UF</label>
              <vs-select
                id="_form-UF"
                placeholder="Selecione um estado"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.estado"
                style="width:100%"
                @change="fnCidade()"
                >
                <vs-select-item :key="index" :value="item.sigla" :text="item.nome" v-for="(item,index) in estados" />
              </vs-select>   
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Cidade">Cidade</label>
                  <vs-select
                id="_form-UF"
                placeholder="Selecione uma cidade"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.cidade"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.nome" :text="item.nome" v-for="(item,index) in cidades" />
              </vs-select>   
          </div>
        </div>
        <h4 class="mb-3">Responsável</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="_form-responsavel">Nome do Responsável</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.responsavelNome"
              id="_form-responsavel"
              maxlength="100"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-telFixo">Telefone fixo</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.telefoneFixo"
              id="_form-telFixo"
              maxlength="10"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-telCelular">Telefone celular</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.telefoneCelular"
              id="_form-telCelular"
              maxlength="11"
              required
            />
          </div>

          <div class="form-group col-md-6">
            <label for="_form-CPF">CPFs</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.cpf"
              id="_form-CPF"
              maxlength="11"
              v-mask="'###########'"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-RG">RG</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.rg"
              id="_form-RG"
              maxlength="20"
              required
            />
          </div>
        </div>
        <div style="display: flex; jusify-content: flex-end">
          <button class="btn btn-primary ml-auto" @click.prevent="fnCadastra">
            Salvar
          </button>
        </div>
      </form>
      <form
        style="padding: 15px; margin-bottom: 30px"
        v-show="etapa == 'Socios'"
      >
        <h4 class="mb-3">Cadastro de sócios</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="_form-NomeSocio">Nome</label>
            <input
              type="text"
              class="form-control"
              v-model="socio.socioNome"
              id="_form-NomeSocio"
              required
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-CPF">CPF</label>
            <input
              type="text"
              class="form-control"
              v-model="socio.socioCPF"
              id="_form-CPF"
              required
              maxlength="11"
              v-mask="'###########'"
              v-on:change="validaCPF(socio.socioCPF)"
  />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-participacao">Participação</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="socio.socioParticipacao"
              id="_form-participacao"
              required
            />
          </div>
        </div>
        <div style="display: flex; jusify-content: flex-end">
          <button
            class="btn btn-primary ml-auto"
            @click.prevent="fnCadastraSocio"
          >
            Salvar
          </button>
        </div>
        <hr />
        <div class="" v-show="socios">
          <h4 class="col-sm-12"></h4>

          <div style="padding: 15px">
            <vs-table :data="socios">
              <template slot="header">
                <h3>Sócios cadastrados</h3>
              </template>
              <template slot="thead">
                <vs-th :style="'width:96px'"> Ações </vs-th>
                <vs-th> Nome </vs-th>
                <vs-th style="width: 150px"> CPF </vs-th>
                <vs-th style="width: 150px"> Participação </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <a
                      class="icone-editar"
                      data-editar
                      @click="fnEditar(indextr)"
                      title="Editar"
                    >
                      <i class="i-circled i-small i-light icon-line-edit"></i>
                    </a>
                    <a
                      class="icone-editar"
                      data-deletar
                      @click="fnDeletar(tr.etapaAId)"
                      title="Editar"
                    >
                      <i class="i-circled i-small i-light icon-trash"></i>
                    </a>
                  </vs-td>

                  <vs-td :data="tr.socioNome">
                    {{ tr.socioNome }}
                  </vs-td>
                  <vs-td :data="tr.socioCPF">
                    {{ tr.socioCPF }}
                  </vs-td>
                  <vs-td :data="tr.socioParticipacao">
                    {{ tr.socioParticipacao }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </form>
    </div>
    {{ clienteId }}
  </div>
</template>

<script>
import { getSuccess, clientKey, validarCPF } from "../../../global/utils";

export default {
  data() {
    return {
      cadastro: {
        ContratacaoId: null,
      },
      estados: [],
      cidades: [],
      socios: [],
      servico: null,
      textoAjuda: null,
      popupActivo: false,

      socio: {
        etapaId: null,
      },
      clienteId: null,
      etapa: "Empresa",
    };
  },
  mounted() {
    this.fnEstados();
    if (this.$route.params.idEtapa != undefined) {
      this.fnGetCadastro();
      this.fnGetSocios();
    } else {
      this.fnGetContratacao();
    }
  },
  methods: {
    async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_01`)
        .then((res) => {
          this.cadastro.ContratacaoId = res.data.contratacaoId;
          this.clienteId = res.data.clienteId;
          if (res.data.contratacoesEVO01 != null) {
            this.cadastro = res.data.contratacoesEVO01;
            var pushTo = `/areacliente/contrato/etapa1/${
              this.$route.params.codigoContrato
            }/${parseInt(res.data.contratacoesEVO01.etapaId)}`;
            this.$router.push({ path: pushTo });
          }
          if (res.data.contratacoesEVO01.contratacoesEVO01A != null) {
            this.socios = res.data.contratacoesEVO01.contratacoesEVO01A;
          }
        })
        .catch(() => {});
      await this.$http
        .get(`contratacao/lista/${this.$route.params.codigoContrato}`)
        .then((res) => {
          this.servico = res.data.servicos;
          this.textoAjuda = this.servico.textoAjuda01;
        });
    },validaCPF(){
      console.log(this.socio.socioCPF);
      var cpfValido = validarCPF(this.socio.socioCPF);
      if(!cpfValido){
         this.$toasted.global.defaultInfo({
            msg: "CPF inválido",
          });
          this.socio.socioCPF = null;
      }
    },async fnGetSocios() {
      await this.$http
        .get(`etapa_01A/socio/${this.$route.params.idEtapa}`)
        .then((res) => {
          this.socios = res.data;
        })
        .catch(() => {});
    },
    async fnGetCadastro() {
      this.socio.etapaId = this.$route.params.idEtapa;
      await this.$http
        .get(`etapa_01/${this.$route.params.idEtapa}`)
        .then((res) => {
          this.cadastro = null;
          this.cadastro = res.data;
        })
        .catch(() => {});
    },
    fnEstapa(val) {
      if (this.cadastro.etapaId == undefined) {
        if (val == "Socios") {
          this.$toasted.global.defaultInfo({
            msg: "Finalize o cadastro da empresa.",
          });
        }
      } else {
        this.etapa = val;
      }
    },
    async fnEstados(){
      this.$http.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados")
      .then((res) => {
        var estados = res.data
        console.log(estados.sort(function (a, b) {
          console.log(a.nome);
          if (a.nome > b.nome) {
            return 1;
          }
          if (a.nome < b.nome) {
            return -1;
          }
          // a must be equal to b
          return 0;
        }))
        this.estados = estados;
      });
    },
    async fnCidade(){
       await this.$http.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados/"+this.cadastro.estado+"/municipios")
        .then((res) => {
          var cidades = res.data
          console.log(cidades.sort(function (a, b) {
            console.log(a.nome);
            if (a.nome > b.nome) {
              return 1;
            }
            if (a.nome < b.nome) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }))
          this.cidades = cidades;
        });

    },
    async fnCadastra(e) {
      e.preventDefault();
      const metodo = this.$route.params.idEtapa ? "put" : "post";
      this.cadastro.tsAlteracao = this.$route.params.idEtapa
        ? this.$moment().format()
        : null;
      const completaUrl = this.$route.params.idEtapa
        ? "/" + this.$route.params.idEtapa
        : "";
      await this.$http[metodo]("/etapa_01" + completaUrl, this.cadastro)
        .then((res) => {
          this.cadastro = this.$route.params.idEtapa ? this.cadastro : res.data;
          if (this.$route.params.idEtapa == undefined) {
            var pushTo = `/areacliente/contrato/etapa1/${this.$route.params.codigoContrato}/${this.cadastro.etapaId}`;
            this.$router.push({ path: pushTo });
            this.etapa = "Socios";
          }
          getSuccess();
        })
        .catch(() => {});
    },
    async fnCadastraSocio(e) {
      e.preventDefault();
      const metodo = this.socio.etapaAId ? "put" : "post";
      this.socio.tsAlteracao = this.socio.etapaAId
        ? this.$moment().format()
        : null;
      const completaUrl = this.socio.etapaAId ? "/" + this.socio.etapaAId : "";
      this.socio.etapaId = this.$route.params.idEtapa;
      await this.$http[metodo]("/etapa_01A" + completaUrl, this.socio)
        .then((res) => {
          if (metodo == "post") {
            this.socios.push(res.data);
          }
          this.socio = {
            socioCPF: "",
            socioNome: "",
            socioParticipacao: "",
            etapaId: this.$route.params.idEtapa,
          };
          getSuccess();
        })
        .catch(() => {});
    },
    fnEditar(i) {
      this.socio = this.socios[i];
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_01A/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.socios.map((item) => item.etapaAId).indexOf(val);
          this.socios.splice(i, 1);
          getSuccess();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
</style>